/**
 * Shared layout tokens for « workbook » list pages (Cours-style).
 */

/** Compact pagination model: { type: 'page', page } | { type: 'ellipsis', key } */
export function paginationItems(currentPage, totalPages) {
  if (!totalPages || totalPages < 1) return [];
  if (totalPages <= 8) {
    return Array.from({ length: totalPages }, (_, i) => ({ type: 'page', page: i + 1 }));
  }
  const nodes = [{ type: 'page', page: 1 }];
  const left = Math.max(2, currentPage - 1);
  const right = Math.min(totalPages - 1, currentPage + 1);
  if (left > 2) nodes.push({ type: 'ellipsis', key: 'el-start' });
  for (let p = left; p <= right; p++) nodes.push({ type: 'page', page: p });
  if (right < totalPages - 1) nodes.push({ type: 'ellipsis', key: 'el-end' });
  nodes.push({ type: 'page', page: totalPages });
  return nodes;
}

export const FORMA_LINK_BTN =
  'inline-flex shrink-0 items-center gap-2 rounded-xl bg-forma-600 px-5 py-2.5 text-sm font-semibold text-white shadow-md transition hover:bg-forma-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forma-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-950';
